import React from 'react'

const Orders = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/orders',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd' strokeLinecap='round'>
      <path
        d='M17.847 8.439c.1.505.153 1.027.153 1.561 0 4.414-3.586 8-8 8s-8-3.586-8-8 3.586-8 8-8c1.084 0 2.118.216 3.062.608'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        stroke={secondaryColor}
        strokeWidth='2'
        strokeLinejoin='round'
        d='M7 8.283l2.757 2.757L16.797 4'
      />
    </g>
  </svg>
)

export default Orders
